/**
 * Voice intent router — decide which page the transcribed question should
 * be sent to. Lightweight keyword matching in 8 languages.
 * Returns { path, query } to be joined into a URL.
 */

const STOPWORDS = /^(com o|com a|para o|para a|to the|with the|with my|sobre o|sobre a|um|uma|the|a|an)\b/i;

// Order matters — more specific matches first.
const INTENT_RULES = [
  {
    path: "/coach",
    patterns: [
      /\bcoach(ing)?\b/i,
      /\bmentor(ia)?\b/i,
      /\bconselh(eiro|ar|o)\b/i,
      /\bdívida(s)?\b/i,
      /\borçament(o|ário)\b/i,
      /\bbudget\b/i,
      /\bdebt\b/i,
      /\bhabito(s)?\b/i,
      /\bdeuda(s)?\b/i,
      /\bpresupuesto\b/i,
      /\bschuld(en)?\b/i,
      /\bdette(s)?\b/i,
      /\b債務|借金|予算\b/,
      /\b债务|预算\b/,
      /\bकर्ज|बजट\b/,
    ],
  },
  {
    path: "/comparador",
    patterns: [
      /\bcompar(ar|ação|a)\b/i,
      /\bcompare(r)?\b/i,
      /\bversus\b/i,
      /\bvs\.?\b/i,
      /\blado a lado\b/i,
      /\bside\s?by\s?side\b/i,
      /\bvergleich(en)?\b/i,
      /\bcomparer\b/i,
      /\b比较|对比\b/,
      /\b比較\b/,
      /\bतुलना\b/,
    ],
  },
  {
    path: "/simulador",
    patterns: [
      /\bsimulador\b/i,
      /\bsimulate?\b/i,
      /\bsimula(re|r|tore)?\b/i,
      /\be se\b/i,
      /\bwhat if\b/i,
      /\by si\b/i,
      /\bet si\b/i,
      /\bwas wäre\b/i,
      /\b模拟|シミュレ|सिमुलेट\b/i,
    ],
  },
  {
    path: "/mercado",
    patterns: [
      /\bmercado\b/i,
      /\bmarket\b/i,
      /\bcotaç(ão|ões)\b/i,
      /\bpreço\b/i,
      /\bquote\b/i,
      /\bprice\b/i,
      /\bcâmbio\b/i,
      /\bexchange rate\b/i,
      /\bbolsa\b/i,
      /\bmarché\b/i,
      /\bmarkt\b/i,
      /\bcotización\b/i,
      /\bquanto (está|custa|vale|é)\b/i,
      /\b(cotação|valor) d[ao]\b/i,
      /\bhow much (is|costs)\b/i,
      /\b市场|行情|価格\b/i,
      /\bबाज़ार|कीमत\b/,
    ],
  },
  {
    path: "/watchlist",
    patterns: [
      /\bwatch\s?list\b/i,
      /\bminha lista\b/i,
      /\balerta(s)?\b/i,
      /\balert(s)?\b/i,
      /\bmonitorar\b/i,
      /\bacompanhar\b/i,
    ],
  },
  {
    path: "/semanal",
    patterns: [
      /\bdecis(ão|ões) da semana\b/i,
      /\bweekly\s?(decision|pick)?\b/i,
      /\bdecisión de la semana\b/i,
      /\bdécision de la semaine\b/i,
      /\bwochenentscheidung\b/i,
      /\b周决策\b/i,
    ],
  },
  {
    path: "/geografia",
    patterns: [
      /\bgeografia\b/i,
      /\bgeography\b/i,
      /\bpaís(es)?\b/i,
      /\bcountry\b/i,
      /\bpays\b/i,
      /\bland\b/i,
      /\bcidade(s)?\b/i,
    ],
  },
  {
    path: "/planos",
    patterns: [
      /\bplano(s)?\b/i,
      /\bplan(es|s)?\b/i,
      /\bpreço(s)?\b/i,
      /\bassinatura\b/i,
      /\bsubscription\b/i,
      /\bpricing\b/i,
      /\btarif(a|s)?\b/i,
    ],
  },
  {
    path: "/perfil",
    patterns: [
      /\bperfil de risco\b/i,
      /\brisk profile\b/i,
      /\bqual meu perfil\b/i,
      /\bperfil de riesgo\b/i,
      /\bprofil de risque\b/i,
    ],
  },
];

export function routeVoiceIntent(transcription) {
  const text = (transcription || "").trim();
  if (!text) return { path: "/assistente", query: "" };
  for (const rule of INTENT_RULES) {
    for (const re of rule.patterns) {
      if (re.test(text)) {
        return { path: rule.path, query: text };
      }
    }
  }
  // Default — general AI question goes to the assistant
  return { path: "/assistente", query: text };
}
